import { Exception } from "../../Exceptions/Exception";
import NumberUtils from "../../Utils/NumberUtils";
import ObjUtils from "../../Utils/ObjUtils";
import StringUtils from "../../Utils/StringUtils";
export default class XoneWebCoreResulset {
    /**
     *
     */
    constructor(connection, options) {
        this.m_stringData = ["Valor prueba texto", "Texto corto", "0002346", "Otro texto", "Un texto mas largo de prueba", "Mas texto"];
        this.m_maxRows = 100;
        this.m_keys = [];
        this.isResultset = true;
        this.m_connection = connection;
        this.m_nIterate = -1;
        this.m_options = options;
        this.m_data = [];
        this.m_maxRows = this.m_data.length;
        this.m_keys = [];
        // this.m_parsed=new SqlParser("ROWID");
        // this.m_parsed.ParseSqlString(strCmd)
    }
    async populate(login, password,options) {
        var result = await this.m_connection.fetchDataAsync(login, password,options || this.m_options);
        if (result.hasError == true) {
            throw new Exception(result.err);
        }
        this.m_data = Array.isArray(result.data) ? result.data : [];
        this.m_maxRows = this.m_data.length;
        this.m_keys = this.m_maxRows == 0 ? [] : Object.keys(this.m_data[0]);
        return this;
    }
    getBytes(fld) {
        return null;
    }
    getColumnCount() {
        return this.m_maxRows == 0 ? 0 : this.m_keys.length;
    }
    getColumnTypes() {
        return [1, 2, 3, 4, 5, 6, 7, 8];
    }
    getColumnName(ordinal) {
        return this.m_maxRows == 0 ? 0 : this.m_keys[ordinal];
    }
    getData() {
        return this.m_data;
    }
    close() {
        this.m_nIterate = -1;
        this.m_data = null;
        this.m_maxRows = 0;
    }
    resolverField(fld) {
        if (typeof fld == "number")
            return this.m_keys[fld];
        return fld;
    }
    getValue(fld, nType) {
        switch (nType) {
            case 0: // Numero
                return NumberUtils.SafeToInt(this.m_data[this.m_nIterate][this.resolverField(fld)]);
            case 2:
                return NumberUtils.SafeToDouble(this.m_data[this.m_nIterate][this.resolverField(fld)]);
            case 3:
                return ObjUtils.SafeToDate(this.m_data[this.m_nIterate][this.resolverField(fld)]);
            default:
                return StringUtils.SafeToString(this.m_data[this.m_nIterate][this.resolverField(fld)]);
        }
    }
    getString(fld) {
        return this.getValue(fld, 1);
    }
    getInt(fld) {
        return this.getValue(fld, 0);
    }
    getDate(fld) {
        return this.getValue(fld, 3);
    }
    get PageLen() {
        var _a, _b;
        return ((_b = (_a = this.m_options) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.length) || -1;
    }
    get PageCache() {
        var _a, _b;
        return ((_b = (_a = this.m_options) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.cache) || -1;
    }
    async next() {
        // if (this.PageLen > 0) {
        //     if (this.PageCache > 0) {
        //     } else {
        //         await this.populate();
        //     }
        // }
        return ++this.m_nIterate < this.m_maxRows;
    }
    async EOF() {
        return this.m_nIterate >= this.m_maxRows;
    }
    async moveTo(position) {
        return position == this.m_maxRows || (this.m_nIterate = position) == this.m_maxRows;
    }
}

//# sourceMappingURL=XoneWebCoreResulset.js.map
